/**
 * EffectPresetsBrowserWrapper Component
 * Wrapper for Effect Presets Browser modal
 */

import React from 'react';
import { EffectPresetsBrowser } from '../effects';
import { toast } from 'sonner';

export const EffectPresetsBrowserWrapper = ({
  isOpen,
  onClose,
  advancedEffectsData,
  setAdvancedEffectsData,
  selectedEffectsTrackId,
  updateTrack,
  userId,
}) => {
  const handleApplyPreset = (preset) => {
    if (preset.settings) {
      setAdvancedEffectsData(preset.settings);
      if (selectedEffectsTrackId) {
        updateTrack(selectedEffectsTrackId, { advancedEffects: preset.settings });
      }
      toast.success(`Applied "${preset.name}" preset`);
    }
    onClose();
  };

  return (
    <EffectPresetsBrowser
      isOpen={isOpen}
      onClose={onClose}
      onApplyPreset={handleApplyPreset}
      currentEffects={advancedEffectsData}
      userId={userId}
    />
  );
};

export default EffectPresetsBrowserWrapper;
